export type TagResponse = {
  id: string;
  name: string;
  color: keyof typeof TAG_COLORS;
  icon: TAG_ICONS;
  info: string;
  primaryButton: TagButton;
  secondaryButton: TagButton;
  label: TagLabel | null;
  tagId: string;
};

export type TagPayload = {
  id: string;
  name: string;
  color: keyof typeof TAG_COLORS;
  icon: TAG_ICONS;
  info: string;
  primaryButton: TagButton | null;
  secondaryButton: TagButton | null;
  label: TagLabel | null;
};

export type TagButton = {
  title: string;
  url: string;
};

export type Tag = {
  id: string;
  name: string;
  color: keyof typeof TAG_COLORS;
  icon: TAG_ICONS;
  info: string;
  primaryButton: TagButtonForm;
  secondaryButton: TagButtonForm;
  label: TagLabelForm | null;
  tagId: string;
};

type TagButtonForm = {
  isActive: boolean;
} & TagButton;

type TagLabelForm = {
  isActive: boolean;
} & TagLabel;

export type TagLabel = {
  category: LABEL_CATEGORIES;
  value: string;
};

export enum LABEL_CATEGORIES {
  temperature = "temperature",
  volume = "volume",
  weight = "weight",
  height = "height",
  speed = "speed",
  sound = "sound",
  price = "price",
}

export enum TAG_COLORS {
  anzac = "#E2A74E",
  black = "#000000",
  coralRed = "#FF4444",
  dodgerBlue = "#44BCFF",
  mediumPurple = "#8F4EE2",
  white = "#FFFFFF",
  wildWillow = "#A4C975",
}

export enum TAG_ICONS {
  backpack = "backpack",
  // barrel = "barrel",
  boots = "boots",
  // brush = "brush",
  // bulb = "bulb",
  camera = "camera",
  // car = "car",
  // flask = "flask",
  glasses = "glasses",
  megaphone = "megaphone",
  // monument = "monument",
  // object = "object",
  art = "palette",
  person = "person",
  pin = "pin",
  shirt = "shirt",
  ski = "ski",
  snowboard = "snowboard",
  table = "table",
  // temperature = "temperature",
  watch = "watch",
}
